// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MergeCellsOutlinedSvg from "@fishx/icons-svg/es/asn/MergeCellsOutlined";
import FishxIcon from '../components/FishxIcon';

var MergeCellsOutlined = function MergeCellsOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: MergeCellsOutlinedSvg
  }));
};

MergeCellsOutlined.displayName = 'MergeCellsOutlined';
export default React.forwardRef(MergeCellsOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/MergeCellsOutlined.js
// module id = 3119
// module chunks = 0